import * as React from 'react';
import styled from 'styled-components';

import { Space, Icon } from 'components';

import Searchbar from './Searchbar';
import ManageUsersContext from '../ManageUsersContext';

const TeamsHeader: React.FC<{ justify: 'flex-start' | 'flex-end' }> = ({
  justify,
}) => {
  const { setSearchText, searchText } = React.useContext(ManageUsersContext);

  const textChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <Container wrap $justify={justify}>
      <Searchbar
        allowClear
        placeholder="Search Teams"
        value={searchText}
        onChange={textChangeHandler}
        suffix={<Icon type="search" color="gray5" />}
      />
    </Container>
  );
};

const Container = styled(Space)<{
  $justify: string;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ $justify }) => $justify};
  width: 100%;
`;

export default TeamsHeader;
